export default __webpack_public_path__ + "static/media/wrx.3887d367.png";